import { z } from 'zod';
import {
  BaseResponseSchema,
  dateSchema,
  uuidSchema,
} from './primitives.js';

export const FeatureFlagSchema = z.object({
  id: uuidSchema,
  flagKey: z.string(),
  flagName: z.string(),
  description: z.string().nullable().optional(),
  isEnabled: z.boolean(),
  createdAt: dateSchema,
  updatedAt: dateSchema,
});


export const FeatureFlagKeyParamSchema = z.object({
  flagKey: z.string().min(1),
});


export const CreateFeatureFlagRequestSchema = z.object({
  flagKey: z.string().min(1).max(100).regex(/^[a-z0-9_]+$/i),
  flagName: z.string().min(1).max(255),
  description: z.string().optional(),
  isEnabled: z.boolean().default(false),
});


export const ProviderFeatureFlagListResponseSchema = BaseResponseSchema.extend({
  data: z.object({
    flags: z.array(FeatureFlagSchema),
    count: z.number().int(),
  }),
});
// Inferred types
export type CreateFeatureFlagRequest = z.infer<typeof CreateFeatureFlagRequestSchema>;
export type FeatureFlag = z.infer<typeof FeatureFlagSchema>;
export type FeatureFlagKeyParam = z.infer<typeof FeatureFlagKeyParamSchema>;
export type ProviderFeatureFlagListResponse = z.infer<typeof ProviderFeatureFlagListResponseSchema>;
